import * as actionTypes from "./ActivityFormType";

const INITIAL_STATE = {
    actList:[],
};

const ActivityReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETACTIVITY:
			return {
				...state,
				actList: action.payload.list,
			};
        default:
			return state;
    }
}

export default ActivityReducer;